module.exports = __webpack_public_path__ + "img/商城上海联通流量卡.8f2818dd.png";